var React = require( 'react' );
var createReactClass = require('create-react-class');
var browserHistory = require('react-router').browserHistory;

var BackButton = createReactClass({
    handleClick: function(){
        browserHistory.goBack();
    },

    render: function(){
        return <button className="back-button button success hide-for-medium" onClick={this.handleClick}>Back</button>;
    }
});

module.exports = BackButton;



// WEBPACK FOOTER //
// ./src/common/routes/components/backButton.jsx